export default "__VITE_ASSET__DW$KxiLk__"